export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PALE_PINKISH = 'pale-pinkish',
  PRIMARY_INVERTED = 'primary-inverted',
  GHOST = 'ghost',
}
